// extracted by mini-css-extract-plugin
export default {"description":"ProgramManagerAccessControlView_description__yOdJw","divider":"ProgramManagerAccessControlView_divider__PHKro"};